import {
  cloneElement,
  isValidElement,
  useId,
  useState,
  type FocusEvent,
  type MouseEvent,
  type ReactElement,
} from 'react';

type TooltipChildProps = {
  onMouseEnter?: (event: MouseEvent<HTMLElement>) => void;
  onMouseLeave?: (event: MouseEvent<HTMLElement>) => void;
  onFocus?: (event: FocusEvent<HTMLElement>) => void;
  onBlur?: (event: FocusEvent<HTMLElement>) => void;
  'aria-describedby'?: string;
};

interface ActionTooltipProps {
  label: string;
  children: ReactElement<TooltipChildProps>;
}

export function ActionTooltip({ label, children }: ActionTooltipProps) {
  const [isOpen, setIsOpen] = useState(false);
  const tooltipId = useId();

  if (!isValidElement<TooltipChildProps>(children)) {
    return null;
  }

  return (
    <span className="action-tooltip-wrapper">
      {cloneElement(children, {
        'aria-describedby': isOpen ? tooltipId : undefined,
        onMouseEnter: (event) => {
          children.props.onMouseEnter?.(event);
          setIsOpen(true);
        },
        onMouseLeave: (event) => {
          children.props.onMouseLeave?.(event);
          setIsOpen(false);
        },
        onFocus: (event) => {
          children.props.onFocus?.(event);
          setIsOpen(true);
        },
        onBlur: (event) => {
          children.props.onBlur?.(event);
          setIsOpen(false);
        },
      })}
      {isOpen && (
        <span id={tooltipId} role="tooltip" className="action-tooltip-bubble">
          {label}
        </span>
      )}
    </span>
  );
}